import PaymentsInbox from './PaymentsInbox';

export default PaymentsInbox;
